import React, { useState } from 'react';
import { Tooltip, IconButton, IconButtonProps } from '@material-ui/core';
import * as Icon from '../Icon';
import useStyles from './styles';

interface Props extends IconButtonProps {
  tooltip?: string
  icon: Icon.IconComponent
}

const ActionButton: React.FC<Props> = (props) => {
  const classes = useStyles();
  const [clicked, setClicked] = useState(false);
  const BtnIcon = props.icon;

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    props?.onClick?.(event)
    setClicked(true);
    setTimeout(() => setClicked(false), 3000);
  };

  return (
    <Tooltip
      classes={{ tooltip: classes.tooltip }}
      title={props.tooltip}
    >
      <IconButton {...props} onClick={handleClick}>
        {clicked ? <Icon.Check /> : <BtnIcon />}
      </IconButton>
    </Tooltip>
  );
}

export default ActionButton;
